/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AccountIsOutOfBandQueryVariables = GraphQL.Exact<{
  accountId: GraphQL.Scalars['AccountId']['input'];
}>;


export type AccountIsOutOfBandQuery = { readonly __typename?: 'Query', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId, readonly isOutOfBand: boolean } | null };


export const AccountIsOutOfBandDocument = gql`
    query AccountIsOutOfBand($accountId: AccountId!) {
  account(id: $accountId) {
    id
    isOutOfBand
  }
}
    `;

/**
 * __useAccountIsOutOfBandQuery__
 *
 * To run a query within a React component, call `useAccountIsOutOfBandQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountIsOutOfBandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountIsOutOfBandQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountIsOutOfBandQuery(baseOptions: Apollo.QueryHookOptions<AccountIsOutOfBandQuery, AccountIsOutOfBandQueryVariables> & ({ variables: AccountIsOutOfBandQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountIsOutOfBandQuery, AccountIsOutOfBandQueryVariables>(AccountIsOutOfBandDocument, options);
      }
export function useAccountIsOutOfBandLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountIsOutOfBandQuery, AccountIsOutOfBandQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountIsOutOfBandQuery, AccountIsOutOfBandQueryVariables>(AccountIsOutOfBandDocument, options);
        }
export function useAccountIsOutOfBandSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountIsOutOfBandQuery, AccountIsOutOfBandQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountIsOutOfBandQuery, AccountIsOutOfBandQueryVariables>(AccountIsOutOfBandDocument, options);
        }
export type AccountIsOutOfBandQueryHookResult = ReturnType<typeof useAccountIsOutOfBandQuery>;
export type AccountIsOutOfBandLazyQueryHookResult = ReturnType<typeof useAccountIsOutOfBandLazyQuery>;
export type AccountIsOutOfBandSuspenseQueryHookResult = ReturnType<typeof useAccountIsOutOfBandSuspenseQuery>;
export type AccountIsOutOfBandQueryResult = Apollo.QueryResult<AccountIsOutOfBandQuery, AccountIsOutOfBandQueryVariables>;